import callAPiBase from './base';

const schoolsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolList',
      method: 'GET',
      useToken: true,
      title: 'School - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCreate',
      method: 'POST',
      useToken: true,
      title: 'School - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolUpdate',
      method: 'PUT',
      useToken: true,
      title: 'School - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolDelete',
      method: 'DELETE',
      useToken: true,
      title: 'School - Delete',
      params,
    }),
  updateReportLimit: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolUpdateReportLimit',
      method: 'POST',
      useToken: true,
      title: 'School - Update Report Limit',
      data,
    }),
  createRequestProfile: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCreateProfileRequest',
      method: 'POST',
      useToken: true,
      title: 'School - Create Request Profile',
      data,
    }),
  getCourse: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolCourseList',
      method: 'GET',
      useToken: true,
      title: 'School - Get List',
      params,
    }),
  createCourse: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCourseCreate',
      method: 'POST',
      useToken: true,
      title: 'School - Create',
      data,
    }),
  updateCourse: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCourseUpdate',
      method: 'PUT',
      useToken: true,
      title: 'School - Update',
      data,
    }),
  deleteCourse: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolCourseDelete',
      method: 'DELETE',
      useToken: true,
      title: 'School - Delete',
      params,
    }),
};

export { schoolsApi };
export default schoolsApi;
